import React, { useRef, useState } from 'react';
import Lightbox from './Lightbox';
import { GALLERY, thumbSrc } from './gallery';

const FEATURED = GALLERY.map((it, i) => ({ it, i })).filter(({ it }) => it.featured);

export default function Console() {
  const [shot, setShot] = useState(null);
  const openerRef = useRef(null);
  const openShot = (e, i) => { openerRef.current = e.currentTarget; setShot(i); };
  return (
    <section className="wx-section kz-section kz-glow-a" id="console">
      <div className="kz-container">
        <p className="kz-kicker">The console</p>
        <h2 className="kz-h2">One console for the whole operation.</h2>
        <p className="kz-lead">
          Screens from the Kizashi Console UI guide, captured from the seeded demo workspace; every capability is also a
          REST API. Click any screen to open it full size and page through all {GALLERY.length}.
        </p>
        <div className="kz-shots">
          {FEATURED.map(({ it, i }, k) => (
            <figure className={`kz-shot ${k === 0 ? 'kz-shot-lead' : ''}`} key={it.f}>
              <button type="button" className="kz-shot-frame" onClick={(e) => openShot(e, i)}
                aria-label={`Open ${it.t} screenshot full size (${i + 1} of ${GALLERY.length})`}>
                <img src={`/console/${it.f}.webp`} alt={`Kizashi console: ${it.t} page`} width="1200" height="833" loading="lazy" decoding="async" />
                <span className="kz-shot-zoom" aria-hidden="true"><i className="fas fa-expand" /></span>
              </button>
              <figcaption><b>{it.t}</b> {it.d}</figcaption>
            </figure>
          ))}
        </div>
        <div className="kz-more-shots">
          <h3>All {GALLERY.length} screens</h3>
          <ul>
            {GALLERY.map((it, i) => (
              <li key={it.f}>
                <button type="button" onClick={(e) => openShot(e, i)} aria-label={`Open ${it.t} screenshot full size (${i + 1} of ${GALLERY.length})`}>
                  <img src={thumbSrc(it.f)} alt="" width="240" height="167" loading="lazy" decoding="async" />
                  <span>{it.t}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
        <Lightbox items={GALLERY} index={shot} onChange={setShot} onClose={() => setShot(null)} returnTo={openerRef} />
      </div>
    </section>
  );
}
